// @ts-nocheck - FormStatic/FormInput/FormDate/FormFileUpload
import React, { useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import FormFileUpload from '../../common/FormFileUpload';
import KwPanel from '../../common/KwPanel';
import { useForm } from 'react-hook-form';
import FormInput from '../../common/FormInput';
import FormDate from '../../common/FormDate';
import FormStatic from '../../common/FormStatic';
import { uploadToKeyPool } from '../../../actions/skuActions';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export interface KeyPoolUploadProps {
  done: () => void;
  cancel: () => void;
  gameId: string;
  gameName: string;
  skuId: string;
  skuName: string;
  keyWorkflowId: string;
  keyWorkflowName: string;
}

function KeyPoolUpload({
  done,
  cancel,
  gameId,
  gameName,
  skuId,
  skuName,
  keyWorkflowId,
  keyWorkflowName,
}: KeyPoolUploadProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [file, setFile] = useState<any>();

  const addFiles = (files: any[]) => {
    setFile(files[0]);
  };
  const onSubmit = (data: any) => {
    uploadToKeyPool(skuId, gameId, keyWorkflowId, { file, ...data })
      .then(() => {
        toast.success(t('Upload queued. Processing started.'));
        done();
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to upload keys'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Upload to key pool')}
      cancel={cancel}
      bar={
        <input
          type="submit"
          value={t('Upload')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          disabled={!file}
        />
      }
    >
      <KwPanel className="mb-4">
        <FormStatic label={t('Game')}>{gameName}</FormStatic>
        <FormStatic label={t('SKU')}>{skuName}</FormStatic>
        <FormStatic label={t('Pool')}>{keyWorkflowName}</FormStatic>
        <FormInput
          register={register}
          name="tag"
          label={t('Tag')}
          placeholder={t('Optional')}
        />
        <FormDate
          register={register}
          name="expiryDate"
          label={t('Expiry date')}
          placeholder={t('Optional')}
        />
        <FormFileUpload
          name="files"
          required
          errorMessage={t('Required')}
          label={t('Upload key file')}
          error={errors.files}
          addFiles={addFiles}
          removeFile={() => setFile(null)}
          files={file ? [file] : []}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default KeyPoolUpload;
